// Generated by psc version 0.10.2
"use strict";
var Prelude = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Prelude.purs");
var Control_Comonad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Comonad.purs");
var Control_Extend = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-control/src/Control/Extend.purs");
var Data_Functor_Invariant = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-invariant/src/Data/Functor/Invariant.purs");
var Data_HeytingAlgebra = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/HeytingAlgebra.purs");
var Data_Monoid = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-monoid/src/Data/Monoid.purs");
var Data_Newtype = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-newtype/src/Data/Newtype.purs");
var Data_Eq = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Eq.purs");
var Data_Ord = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Ord.purs");
var Data_Bounded = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Bounded.purs");
var Data_Functor = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Functor.purs");
var Control_Apply = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Apply.purs");
var Control_Applicative = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Applicative.purs");
var Control_Bind = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Bind.purs");
var Control_Monad = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Control/Monad.purs");
var Data_Show = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Show.purs");
var Data_Semigroup = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semigroup.purs");
var Data_Semiring = require("/Users/ropilz/Workspace/purs-2048/bower_components/purescript-prelude/src/Data/Semiring.purs");
var Disj = function (x) {
    return x;
};
var showDisj = function (dictShow) {
    return new Data_Show.Show(function (v) {
        return "(Disj " + (Data_Show.show(dictShow)(v) + ")");
    });
};
var semiringDisj = function (dictHeytingAlgebra) {
    return new Data_Semiring.Semiring(function (v) {
        return function (v1) {
            return Data_HeytingAlgebra.disj(dictHeytingAlgebra)(v)(v1);
        };
    }, function (v) {
        return function (v1) {
            return Data_HeytingAlgebra.conj(dictHeytingAlgebra)(v)(v1);
        };
    }, Data_HeytingAlgebra.tt(dictHeytingAlgebra), Data_HeytingAlgebra.ff(dictHeytingAlgebra));
};
var semigroupDisj = function (dictHeytingAlgebra) {
    return new Data_Semigroup.Semigroup(function (v) {
        return function (v1) {
            return Data_HeytingAlgebra.disj(dictHeytingAlgebra)(v)(v1);
        };
    });
};
var ordDisj = function (dictOrd) {
    return dictOrd;
};
var newtypeDisj = new Data_Newtype.Newtype(function (n) {
    return n;
}, Disj);
var monoidDisj = function (dictHeytingAlgebra) {
    return new Data_Monoid.Monoid(function () {
        return semigroupDisj(dictHeytingAlgebra);
    }, Data_HeytingAlgebra.ff(dictHeytingAlgebra));
};
var invariantDisj = new Data_Functor_Invariant.Invariant(function (f) {
    return function (v) {
        return function (v1) {
            return f(v1);
        };
    };
});
var functorDisj = new Data_Functor.Functor(function (f) {
    return function (v) {
        return f(v);
    };
});
var extendDisj = new Control_Extend.Extend(function () {
    return functorDisj;
}, function (f) {
    return function (x) {
        return f(x);
    };
});
var eqDisj = function (dictEq) {
    return dictEq;
};
var comonadDisj = new Control_Comonad.Comonad(function () {
    return extendDisj;
}, Data_Newtype.unwrap(newtypeDisj));
var boundedDisj = function (dictBounded) {
    return dictBounded;
};
var applyDisj = new Control_Apply.Apply(function () {
    return functorDisj;
}, function (v) {
    return function (v1) {
        return v(v1);
    };
});
var bindDisj = new Control_Bind.Bind(function () {
    return applyDisj;
}, function (v) {
    return function (f) {
        return f(v);
    };
});
var applicativeDisj = new Control_Applicative.Applicative(function () {
    return applyDisj;
}, Disj);
var monadDisj = new Control_Monad.Monad(function () {
    return applicativeDisj;
}, function () {
    return bindDisj;
});
module.exports = {
    Disj: Disj, 
    newtypeDisj: newtypeDisj, 
    eqDisj: eqDisj, 
    ordDisj: ordDisj, 
    boundedDisj: boundedDisj, 
    functorDisj: functorDisj, 
    invariantDisj: invariantDisj, 
    applyDisj: applyDisj, 
    applicativeDisj: applicativeDisj, 
    bindDisj: bindDisj, 
    monadDisj: monadDisj, 
    extendDisj: extendDisj, 
    comonadDisj: comonadDisj, 
    showDisj: showDisj, 
    semigroupDisj: semigroupDisj, 
    monoidDisj: monoidDisj, 
    semiringDisj: semiringDisj
};



//////////////////
// WEBPACK FOOTER
// ../bower_components/purescript-monoid/src/Data/Monoid/Disj.purs
// module id = 45
// module chunks = 0